import helper from '@/libs/forms';

const getFields = (
  entities,
  entityRequired,
  entityFieldClass,
  newEntityClicked,
) => {
  const entityField = helper.simpleSelect(
    'Filling out as:',
    'entity',
    entityRequired,
    entities,
    null,
    null,
    null,
  );
  entityField.styleClasses += ` ${entityFieldClass}`;

  entityField.buttons = [
    {
      classes: 'btn inline-select-btn',
      label: '+ New',
      onclick: newEntityClicked || (() => {}),
    },
  ];

  return [entityField];
};


export default {
  schema: (entities, entityRequired, entityFieldClass, newEntityClicked) => ({
    fields: getFields(entities, entityRequired, entityFieldClass, newEntityClicked),
  }),
  options: helper.options('application-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/application/form/schema.js